import { Button, DataSource, Layout, Panel, SearchPanel, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutCarrierOfferList extends Layout {
    buttonViewInNewTab: Button;
    panelOffersListContainer: Panel;
    searchpanelSearchOffers: SearchPanel;
    sourceCarrierOfferList: DataSource;
    tableOffers: Table;
    textboxCarrierName: Textbox;
    textboxDateRange: Textbox;
    textboxEnteredUserId: Textbox;
    textboxOrderId: Textbox;
    textboxSource: Textbox;
    textboxStatus: Textbox;
}
